/*
 * 会话列表
 */
import store from '@/store'

// 如果会话对象不是好友，需要更新好友名片
function updateSessionAccount(sessions) {
    let accountsNeedSearch = []
    sessions.forEach(item => {
        if (item.scene === 'p2p') {
            // 如果不存在缓存资料
            if (!store.state.chat.userInfos[item.to]) {
                accountsNeedSearch.push(item.to)
            }
        }
    })
    if (accountsNeedSearch.length > 0) {
        store.dispatch('chat/searchUsers', {
            accounts: accountsNeedSearch,
        })
    }
}

// onSessions只在初始化完成后回调
export function onSessions(sessions) {
    sessions.forEach(item => {
        if (item.lastMsg && item.lastMsg.text.startsWith('Congratulations! You have success') && item.unread) {
            item.unread--
        }
    })
    // updateSessionAccount(sessions)
    store.commit('chat/updateSessions', sessions)
    store.commit('chat/setNimHasContact', true)
    // store.commit('chat/initLocalMsgs', sessions)
}

export function onUpdateSession(session) {
    let sessions = [session]
    sessions.forEach(item => {
        if (item.lastMsg && item.lastMsg.text.startsWith('Congratulations! You have success') && item.unread) {
            item.unread--
        }
    })
    // updateSessionAccount(sessions)
    store.commit('chat/updateSessions', sessions)
}

export function setCurrSession({state, commit, dispatch}, sessionId) {
    const nim = state.nim
    if (sessionId) {
        commit('updateCurrSessionId', {
            type: 'init',
            sessionId,
        })
        if (nim) {
            // 如果在聊天页面刷新，此时还没有nim实例，需要在onSessions里同步
            nim.setCurrSession(sessionId)
            commit('updateCurrSessionMsgs', {
                type: 'init',
                sessionId,
            })
            // 发送已读回执
            // dispatch('sendMsgReceipt')
        }
    }
}

export function resetCurrSession({state, commit}) {
    const nim = state.nim
    nim.resetCurrSession()
    commit('updateCurrSessionMsgs', {
        type: 'destroy',
    })
}
